import fetch, { METHOD } from '../fetch'

export const get = async () => {
  const { status, items } = await fetch(METHOD.GET, '/instagram/get')
  if (status && Array.isArray(items)) {
    return items
  }
  return false
}
